<template>
	<div class="SocialmediaCronWorksEditor">
		<v-card>
			<v-toolbar dark color="grey darken-3">
				<v-btn icon dark @click="closeEditor(false)">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>Düzenle</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items>
					<v-btn dark flat color="error"  @click="askRemove = true" v-if="item.id">SİL</v-btn>
					<v-btn dark flat @click="saveWork()" v-if="item.brand_id">KAYDET</v-btn>
					<v-btn dark flat @click="saveWork()" v-if="!item.brand_id">EKLE</v-btn>
				</v-toolbar-items>
			</v-toolbar>
			<div class="EditorBody">

				<template v-if="isLoading">
					<div class="text-xs-center pa-5">
						<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
						<div class="caption mt-4">İşlem devam ediyor</div>
					</div>
				</template>
				<template v-if="askRemove">
					<div class="text-xs-center">
						<div class="text-xs-center">Silmek istediğinize emin misiniz ? </div>
						<v-btn round color="warning" dark @click="askRemove = false">VAZGEÇ</v-btn>
						<v-btn round color="error" @click="removeWork()" dark>EVET SİL</v-btn>
					</div>
				</template>

				<template v-if="!isLoading">
					<div class="EditorForm">
						<div class="brandDatesSlots">
							<div class="brandSlot">
								<v-combobox v-model="selectedBrand" :items="brands" item-text="brand_name" item-value="id"
									chips label="Marka" hide-details>
									<template slot="selection" slot-scope="data">
										<v-chip :selected="data.selected" :disabled="data.disabled" :key="data.item.id"
											class="v-chip--select-multi" @input="data.parent.selectItem(data.item.id)">
											<v-avatar class="accent white--text">
												<img :src="data.item.logo" alt="">
											</v-avatar>
											{{ data.item.brand_name }}
										</v-chip>
									</template>
								</v-combobox>
							</div>
							<div class="datesSlot">
								<div class="dateSlot">
									<v-menu v-model="menu_date_open" :close-on-content-click="false" :nudge-right="40"
										lazy transition="scale-transition" offset-y max-width="290px">
										<v-text-field slot="activator" v-model="item.date" label="Tarih"
											prepend-icon="event" readonly hide-details></v-text-field>
										<v-date-picker v-model="getDateISO" @input="dateSelected($event)"
											locale="tr-tr"></v-date-picker>
									</v-menu>
								</div>
								<div class="timeSlot">
									<v-menu v-model="menu_time_open" :close-on-content-click="false" :nudge-right="40"
										lazy transition="scale-transition" offset-y max-width="290px">
										<v-text-field slot="activator" v-model="item.time" label="Saat"
											prepend-icon="event" readonly hide-details></v-text-field>
										<v-time-picker v-if="menu_time_open" v-model="item.time" full-width
											format="24hr" @change="timeSelected($event)"></v-time-picker>
									</v-menu>
								</div>
							</div>
						</div>
						<div class="workText">
							<v-textarea label="İçerik Metni" v-model="item.text" outline rows="3"></v-textarea>
						</div>
						<div class="workTags">
							<v-combobox v-model="item.tags" :items="getBrandTokens" :search-input.sync="searchFoTags" outline
								hide-selected hint="En fazla 20 tag" label="Birkaç tag ekleyin" multiple persistent-hint
								small-chips>
								<template slot="no-data">
									<v-list-tile>
										<v-list-tile-content>
											<v-list-tile-title>
												Eşleşen tag bununamadı, eklemek için
												<kbd>enter</kbd> a basın
											</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-combobox>
						</div>
						<div class="platforms">
							<div class="platform">
								<div class="platformTitle">Instagram Hikaye</div>
								<div class="platformBody">
									<v-checkbox v-model="item.platforms.instagram_story.task"
										label="Bu içerikler paylaşılacak" color="pink" hide-details>
									</v-checkbox>
									<vue-amiral-imagelist v-model="item.platforms.instagram_story.items"
										mediagroup="socialmedia_cron" limit="8" sizetype="hvs" />
								</div>
							</div>
							<div class="platform">
								<div class="platformTitle">Instagram Post</div>
								<div class="platformBody">
									<v-checkbox v-model="item.platforms.instagram_post.task"
										label="Bu içerikler paylaşılacak" color="pink" hide-details>
									</v-checkbox>
									<vue-amiral-imagelist v-model="item.platforms.instagram_post.items"
										mediagroup="socialmedia_cron" limit="8" sizetype="hvs" />
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</v-card>
	</div>
</template>

<script>
	export default {
		name: "SocialmediaCronWorksEditor",
		props: ["brands","editor_id"],
		data: () => ({
			isLoading: false,
			askRemove: false,
			menu_date_open: false,
			menu_time_open: false,
			brands: [],
			tags: [],
			searchFoTags: null,
			selectedBrand: null,
			item: {}
		}),
		watch: {  
			"selectedBrand": function (n, o) {
				this.item.brand_id = n.id
			},
			"only_used_days": function (n, o) {
				this.emitChanged();
			},
		},
		mounted(){
			if(this.editor_id == ""){
				this.item = {
					id : "",
					brand_id: "",
					date: "",
					time: "",
					text: "",
					tags: [],
					platforms: {
						instagram_story: {
							task: true,
							items: []
						},
						instagram_post: {
							task: true,
							items: []
						}
					}
				}
				this.item.date = this.$moment().format("DD.MM.YYYY");
				this.item.time = "09:00";
				this.isLoading = false;
			}
			else{
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cron/works/info", {
					params: {
						id : this.editor_id
					}
				}).then(response => {
					this.item = response.body; 
					for(var i in this.brands){
						if(this.brands[i].id == this.item.brand_id){
							this.selectedBrand = this.brands[i]
						}
					}
					this.isLoading = false;
				})
			}

		},
		methods: {
			dateSelected(e) {
				this.menu_date_open = false;
				this.item.date = this.$moment(e, "YYYY-MM-DD").format("DD.MM.YYYY");
			},
			timeSelected(e) {
				this.menu_time_open = false;
			},
			saveWork(){
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cron/works/save", this.item, {
					params: { }
				}).then(response => { 
					this.isLoading = false;  
					this.closeEditor(true)
				})
			},
			closeEditor(reload){
				this.$emit("closeEditor",reload) 
			},
			removeWork(reload){
				this.isLoading = true;
				this.askRemove = false;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cron/works/remove", this.item, {
					params: { }
				}).then(response => { 
					this.isLoading = false;  
					this.closeEditor(true)
				})
			}
		},
		computed: {
			getDateISO() {
				return this.$moment(this.item.date, "DD.MM.YYYY").format("YYYY-MM-DD");
			},
			getBrandTokens(){
				for(var i in this.brands){
					if(this.brands[i].id == this.item.brand_id){
						return this.brands[i].tags || []
					}
				}
				return [];
			}
		}
	}
</script>

<style lang="less">
	.SocialmediaCronWorksEditor {
		.EditorBody {
			padding: 20px;
			min-height: calc(~"100vh - 64px");

			@media(max-width : 960px) {
				min-height: calc(~"100vh - 48px");
			}

			.EditorForm {
				width: 600px;
				max-width: calc(~"100% - 20px");
				margin: 0px auto;
				padding-bottom: 30px;

				.brandDatesSlots {
					display: flex;
					width: 100%;

					@media(max-width : 600px) {
						display: block;
					}

					margin-bottom : 15px;

					.brandSlot {
						flex: 1;
						padding-right: 10px;
					}

					.datesSlot {
						display: flex;
						padding-top: 10px;

						.dateSlot {
							width: 150px;
							padding-right: 10px;
						}

						.timeSlot {
							width: 100px;
						}
					}
				}

				.workText {
					.v-input__slot {
						border-width: 1px !important;
					}
				}

				.workTags {
					.v-input__slot {
						border-width: 1px !important;
					}
				}

				.platforms {
					border-top: 2px dashed #ccc;

					.platform {
						margin-top: 15px;
						border: 2px solid #ccc;

						.platformTitle {
							display: table;
							background-color: #fff;
							padding: 0px 10px;
							margin: -10px 10px 0px 10px;
							font-weight: 600;
							color: rgb(74, 0, 192)
						}

						.platformBody {
							padding: 0px 10px 10px 10px;

							.v-input {
								margin-top: 0px;
							}
						}
					}
				}
			}
		}
	}
</style>